import { MpDivider } from '../Divider'
export default MpDivider

export { MpDivider, MpDividerProps } from './Divider'
